import Vue from 'vue'
import App from './App'
import store from './vuex/'
import router from './router'

import './assets/js/jquery-3.4.1'

Vue.config.productionTip = false;

// 引入 ElementUI
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';
import '../theme/index.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
Vue.use(VueQuillEditor)

// Vue.use(ElementUI)
Vue.use(ElementUI, {
    size: 'small',
});

import {Message} from 'element-ui'

Vue.prototype.$message = function (option){
    option.offset = 80
    return Message(option)
}

// 多语言配置
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

import LangCN from './lang/i18nCN'
import LangEN from './lang/i18nEN'
import LangJP from './lang/i18nJP'
import LangKR from './lang/i18nKR'
import LangHANT from './lang/i18nHANT'

const i18n = new VueI18n({
    locale: 'cn',
    messages: {
        'cn': LangCN,
        'hant': LangHANT,
        'en': LangEN,
        'jp': LangJP,
        'kr': LangKR
    },
    silentTranslationWarn: true,
});

const Util = require('./lib/utils')
Util.setCookie('lang', i18n.locale)

// 树状插件
import Vue2OrgTree from 'vue-tree-color'

Vue.use(Vue2OrgTree)

//复制粘贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 获取服务器选择列表
store.dispatch('getServerGame');
// store.dispatch('getServerOther');

setTimeout(() => {
    store.dispatch('getServerWorld');
},1000)

// 根据路由设置标题
router.beforeEach((to, from, next) => {
    /*路由发生改变修改页面的title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})
/* eslint-disable no-new */
window.ROOT_APP = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    components: {
        App
    },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js